export default __webpack_public_path__ + "static/media/neet_dashbaord_image.91f7414c.png";